import { Grid, Stack, TextField } from "@mui/material"
import SelectBancos from "../../../../../../../../../../../components/SelectsSimpleApiQuery/SelectBancos"
import BasicDatePicker from "../../../../../../../../../../../components/BasicDatePicker"
import { formatarCPFCNPJ, permitirApenasNumeros } from "../../../../../../../../../../../helpers/masks"
import { Moment } from "moment"
import SelectPlanoContas from "../../../../../../../../../../../components/SelectsSimpleApiQuery/SelectPlanoContas"
import { IInternForm } from "../DialogCadastrarRecb"
import { useQuery } from "react-query"
import axiosClient from "../../../../../../../../../../../lib/axios"
import { ContaContabil } from "../../../../../../../../../../../types/api/geral/pesquisar-plano-contas"
import LoadingApiQuery from "../../../../../../../../../../../components/LoadingApiQuery"
import { useFormContext } from "react-hook-form"
import { IDataPublicos } from "../../../../../../../../../../../types/api/geral/pesquisar-publicos"

export default function ChequeForm({
    values,
    handleChangeValues
}: ChequeFormProps) {

    const { getValues } = useFormContext();

    const { isLoading } = useQuery({
        queryKey: ["/contabilidade/plano-contas/pesquisar-plano-contas"],
        queryFn: () =>
            axiosClient.get("/contabilidade/plano-contas/pesquisar-plano-contas", {
                params: {
                    page: 1,
                    sistema_xy: "D-CHE"
                },
            }),
        onSuccess(data) {
            const dadosContabil: ContaContabil[] = data?.data.data || [];
            if (dadosContabil.length === 1 && !values.cheque_conta_contabil) {
                handleChangeValues("cheque_conta_contabil", dadosContabil[0]);
            }
            return;
        },
        retry: false,
        keepPreviousData: true,
        cacheTime: 0,
        enabled: !values.cheque_conta_contabil
    });

    useQuery({
        queryKey: ["/pesquisar-publicos"],
        queryFn: () =>
            axiosClient.get("/pesquisar-publicos", {
                params: {
                    page: 1,
                    tipo_publico: getValues('selecionar_titulos')[0]?.tipo_publico,
                    codigo_publico: getValues('selecionar_titulos')[0]?.codigo_publico,
                    limit: 1
                },
            }),
        onSuccess(data) {
            const dadosPublico: IDataPublicos[] = data?.data.data || [];
            if (dadosPublico.length >= 1) {
                if (!values.cheque_nome_emissor)
                    handleChangeValues("cheque_nome_emissor", dadosPublico[0].nome_pessoa);
                if (!values.cheque_documento)
                    handleChangeValues("cheque_documento", formatarCPFCNPJ(dadosPublico[0].documento_pessoa));
            }
            return;
        },
        retry: false,
        keepPreviousData: true,
        cacheTime: 0,
        enabled: !values.cheque_nome_emissor || !values.cheque_documento
    });

    return (
        <Grid container size={{xs: 12}} spacing={2}>
            <Grid size={{xs: 12, md: 6}}>
                <SelectBancos
                    required
                    value={values.cheque_banco}
                    onChange={(value) => handleChangeValues("cheque_banco", value)}
                />
            </Grid>

            <Grid size={{xs: 12, md: 6}}>
                <BasicDatePicker
                    value={values.cheque_data_vencimento}
                    error={!!(values.cheque_data_vencimento && values.cheque_data_vencimento.isBefore(new Date(), 'day'))}
                    helperText={values.cheque_data_vencimento && values.cheque_data_vencimento.isBefore(new Date(), 'day') ? "Data inválida" : ""}
                    blockPastDates={true}
                    required
                    label="Data vencimento"
                    onChange={(data) => handleChangeValues("cheque_data_vencimento", data as Moment)}
                    formatString='DD/MM/YYYY'
                    readonly={false}
                />
            </Grid>

            <Grid size={{xs: 12, md: 6}}>
                <Stack direction="row" alignItems="center" gap={1}>
                    <TextField
                        label='Agência'
                        type="text"
                        value={values.cheque_agencia || ''}
                        onChange={(e) => handleChangeValues("cheque_agencia", permitirApenasNumeros(e.target.value))}
                    />
                    -
                    <TextField
                        label='Digito'
                        type="text"
                        value={values.cheque_agencia_digito || ''}
                        onChange={(e) => handleChangeValues("cheque_agencia_digito", e.target.value)}
                    />
                </Stack>
            </Grid>

            <Grid size={{xs: 12, md: 6}}>
                <Stack direction="row" alignItems="center" gap={1}>
                    <TextField
                        label='Conta'
                        type="text"
                        value={values.cheque_conta || ''}
                        onChange={(e) => handleChangeValues("cheque_conta", permitirApenasNumeros(e.target.value))}
                    />
                    -
                    <TextField
                        label='Digito'
                        type="text"
                        value={values.cheque_conta_digito || ''}
                        onChange={(e) => handleChangeValues("cheque_conta_digito", e.target.value)}
                    />
                </Stack>
            </Grid>

            <Grid size={{xs: 12}}>
                <TextField
                    required
                    fullWidth
                    label='Nome do emissor'
                    type="text"
                    value={values.cheque_nome_emissor || ''}
                    onChange={(e) => handleChangeValues("cheque_nome_emissor", e.target.value)}
                />
            </Grid>

            <Grid size={{xs: 12, md: 6}}>
                <TextField
                    required
                    fullWidth
                    label='CPF/CNPJ do emissor'
                    type="text"
                    value={values.cheque_documento || ''}
                    onChange={(e) => handleChangeValues("cheque_documento", formatarCPFCNPJ(e.target.value))}
                />
            </Grid>

            <Grid size={{xs: 12, md: 6}}>
                <TextField
                    required
                    fullWidth
                    label='Praça'
                    type="text"
                    value={values.cheque_praca || ''}
                    onChange={(e) => handleChangeValues("cheque_praca", e.target.value)}
                />
            </Grid>

            <Grid size={{xs: 12, md: 6}}>
                <TextField
                    required
                    fullWidth
                    label='Nº cheque'
                    type="text"
                    value={values.cheque_num || ''}
                    onChange={(e) => handleChangeValues("cheque_num", permitirApenasNumeros(e.target.value))}
                />
            </Grid>

            <Grid size={{xs: 12, md: 6}}>
                <TextField
                    required
                    fullWidth
                    label='Sequência cheque'
                    type="text"
                    value={values.cheque_seq || ''}
                    onChange={(e) => handleChangeValues("cheque_seq", e.target.value)}
                />
            </Grid>

            <Grid size={{xs: 12}}>
                {
                    isLoading &&
                    <LoadingApiQuery />
                }
                {
                    !isLoading &&
                    <SelectPlanoContas
                        inputLabel="Conta devedora"
                        value={values.cheque_conta_contabil || null}
                        required
                        onChangeValue={(valor) => handleChangeValues("cheque_conta_contabil", valor)}
                        extraParams={{ sistema_xy: "D-CHE" }}
                    />
                }
            </Grid>
        </Grid>
    )
}
interface ChequeFormProps {
    values: IInternForm,
    handleChangeValues: (prop: keyof IInternForm, value: any) => void
}